var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23.641,18.485,14.732,1.643a3.093,3.093,0,0,0-5.464,0L.359,18.485A3.079,3.079,0,0,0,3.092,23H20.908a3.079,3.079,0,0,0,2.733-4.515ZM12,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,20Zm1-5H11l-.5-8h3Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }